import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { OrganizationWorkspaceAssignment } from "@common/types/organizationWorkspaceAssignment";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { HStack } from "@design-system/HStack/HStack";
import { getVisibleOrgBillingTransferRequest } from "../../helpers/getVisibleOrgBillingTransferRequest";
import { ClientDetailsRow } from "../clientViewConfig";
import styles from "../ClientsView.module.scss";
import { EMPTY_CELL_VALUE } from "./lib";
import { OrgBillingTransferBadge } from "./OrgBillingTransferBadge";

export const BillingOwnerCell = ({
    row,
}: CellContext<
    ViewTableFeatures,
    ClientDetailsRow,
    OrganizationWorkspaceAssignment[]
>) => {
    const organization = useActiveOrganization();

    if (row.original.type === "entity") {
        return EMPTY_CELL_VALUE;
    }

    const workspace = row.getParentRow()?.original ?? row.original;

    if (!workspace.isOrganizationBillingOwner) {
        return <span className={styles.billingOwnerName}>Client</span>;
    }

    if (!organization) {
        return null;
    }

    const transferRequest = getVisibleOrgBillingTransferRequest({
        organization,
        client: workspace,
    });

    return (
        <HStack gap={8} align="center">
            <Tooltip content={organization.name}>
                <span className={styles.billingOwnerName}>Firm</span>
            </Tooltip>
            {transferRequest && (
                <OrgBillingTransferBadge request={transferRequest} />
            )}
        </HStack>
    );
};
